import { useEffect, useRef } from 'react'
import { useRouterState } from '@tanstack/react-router'
import { ConsentBanner } from './ConsentBanner'
import { useConsentStore } from './consent-store'
import { bootAnalytics, trackPageView } from './gtag'

/**
 * Аналитика приложения: подключение GA4, просмотры страниц по роутеру и плашка
 * согласия. Монтируется ОДИН раз в корне маршрута, рядом с `<Head />`.
 *
 * Почему по роутеру, а не по экранам: автоматический `page_view` у GA4
 * выключен (`send_page_view: false`), потому что в SPA он срабатывает один раз
 * за загрузку и считает весь визит одной страницей. Просмотр — свойство
 * АДРЕСА, ровно как заголовок документа, и по той же причине живёт в одном
 * месте: разложенный по экранам вызов забудут на следующем.
 *
 * Порядок в дереве важен. `<Head />` стоит выше и ставит `document.title` в
 * своём эффекте; братья выполняют эффекты по порядку, поэтому в хит попадает
 * заголовок ЭТОЙ страницы, а не предыдущей.
 */
export function Analytics() {
  const path = useRouterState({ select: (s) => s.location.pathname })
  const hydrate = useConsentStore((s) => s.hydrate)
  const sent = useRef<string | null>(null)

  useEffect(() => {
    // Первым делом — сохранённый ответ про cookie: `bootAnalytics` кладёт
    // `consent update` в очередь ДО загрузки тега и читает то же хранилище.
    hydrate()
  }, [hydrate])

  useEffect(() => {
    bootAnalytics(path)
    // Один просмотр на адрес. StrictMode в разработке выполняет эффекты
    // дважды, и без этой отметки каждая страница считалась бы за две.
    if (sent.current === path) return
    sent.current = path
    trackPageView(path, typeof document !== 'undefined' ? document.title : undefined)
  }, [path])

  return <ConsentBanner />
}
